n <template>
  <div class="center-div">
    <a-row class="justify-center">
      <a-col :span="7" >
        <div class="mt-4" style="text-align:center">
          <h4 class="text-bold">Forgotten Password?</h4>
          <span class="text-opacity">Let’s help you get it back now</span>
        </div>
        <div v-show="errorMessages.length > 0 ">
          <error-alert v-for="(msg,index) in errorMessages" :key="index" :message="msg"></error-alert>
        </div>
        <div v-show="successMessage !== ''">
          <success-alert :messages="'successMessage'">
            <span slot="message">
              {{successMessage}}
              <router-link :to="{name: 'login'}">Here</router-link>
            </span>
          </success-alert>
        </div>
        <a-card class="mt-4">
          <a-form :form="form" @submit="resetPassword">
            <a-form-item class="form-input">
              <div
                style="line-height:20px"
                class="text-opacity"
              >Tell us your email address, so we can provide necessary Steps to get your password</div>
            </a-form-item>
            <a-form-item class="form-input">
              <h4 class="text-opacity">Your Email Address</h4>
              <a-input
                v-decorator="['email', { rules: [{ required: true, message: 'Please input your email address' }] }]"
                class="custom-input"
                type="email"
                placeholder="Please Enter your Email Address"
              />
            </a-form-item>
            <a-form-item class="mt-2">
              <button type="submit" class="btn btn-primary">Request Password</button>
            </a-form-item>
            <span>
              Not yet a user,
              <router-link :to="{name: 'register'}">
                <b class="text-purple">Sign up</b>
              </router-link>to create your Account
            </span>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<style scoped>
.btn-primary {
  width: 100%;
  height: 40px;
  padding-top: 0px !important;
}
</style>
<script>
import "@/assets/css/auth.scss";
import ErrorAlert from "@/components/Alerts/Error";
import SuccessAlert from "@/components/Alerts/Success";
export default {
  data() {
    return {
      form: this.$form.createForm(this, { name: "coordinated" }),
      api: this.$baseApi.replace("api/", ""),
      errorMessages: [],
      successMessage: ""
    };
  },
  components: { ErrorAlert, SuccessAlert },
  methods: {
    resetPassword(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const hide = this.$message.loading(
            "Verifying Request, Please hold on a minute"
          );
          let url = this.api + "/password/email";
          let data = {
            username: value.email
          };
          this.$http
            .post(url, data)
            .then(s => {
              this.successMessage =
                "We have sent you a mail with instructions to help you reset your Password";
              setTimeout(hide, 20);
            })
            .catch(err => {
              // this.errorMessages = Object.values(err.response.data);
              setTimeout(hide, 20);
              if (err.response.status === 422) {
                this.errorMessages = Object.values(err.response.data);
              }
            });
        }
      });
    }
  }
};
</script>

